import { render, staticRenderFns } from "./question.vue?vue&type=template&id=890b894a&scoped=true&"
import script from "./question.vue?vue&type=script&lang=js&"
export * from "./question.vue?vue&type=script&lang=js&"
import style0 from "./question.vue?vue&type=style&index=0&id=890b894a&prod&lang=less&scoped=true&"
import style1 from "./question.vue?vue&type=style&index=1&id=890b894a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890b894a",
  null
  
)

export default component.exports